// extracted by mini-css-extract-plugin
module.exports = {"footerPadding":"Footer_footerPadding__2BVX2"};